import styles from "./AnswerOptionCard.module.css";

export type AnswerCardState = "default" | "selected" | "correct" | "incorrect" | "muted";

interface AnswerOptionCardProps {
  letter: string;
  text: string;
  state: AnswerCardState;
  disabled?: boolean;
  onClick?: () => void;
}

export function AnswerOptionCard({ letter, text, state, disabled, onClick }: AnswerOptionCardProps) {
  const classes = [styles.card, state !== "default" ? styles[state] : ""].filter(Boolean).join(" ");
  return (
    <button className={classes} disabled={disabled} onClick={onClick} aria-pressed={state === "selected"}>
      <span className={styles.letter} aria-hidden="true">
        {letter}
      </span>
      <span className={styles.text}>{text}</span>
    </button>
  );
}
